import { primary, index, field, Model, table } from '@tencent/memoire-structured-storage';

var _a, _b;
/**
 * 文档类型
 */


var DOCUMENT_TYPE;

(function (DOCUMENT_TYPE) {
  DOCUMENT_TYPE[DOCUMENT_TYPE["unknown"] = -1] = "unknown";
  DOCUMENT_TYPE[DOCUMENT_TYPE["doc"] = 0] = "doc";
  DOCUMENT_TYPE[DOCUMENT_TYPE["sheet"] = 1] = "sheet";
  DOCUMENT_TYPE[DOCUMENT_TYPE["slide"] = 4] = "slide";
  DOCUMENT_TYPE[DOCUMENT_TYPE["smartSheet"] = 5] = "smartSheet";
  DOCUMENT_TYPE[DOCUMENT_TYPE["smartCanvas"] = 6] = "smartCanvas";
  DOCUMENT_TYPE[DOCUMENT_TYPE["flowchart"] = 7] = "flowchart";
  DOCUMENT_TYPE[DOCUMENT_TYPE["mind"] = 8] = "mind";
  DOCUMENT_TYPE[DOCUMENT_TYPE["pdf"] = 9] = "pdf";
})(DOCUMENT_TYPE || (DOCUMENT_TYPE = {}));
/**
 * 文档类型描述
 */


var DOCUMENT_TYPE_DESC;

(function (DOCUMENT_TYPE_DESC) {
  DOCUMENT_TYPE_DESC["doc"] = "doc";
  DOCUMENT_TYPE_DESC["sheet"] = "sheet";
  DOCUMENT_TYPE_DESC["form"] = "form";
  DOCUMENT_TYPE_DESC["slide"] = "slide";
  DOCUMENT_TYPE_DESC["smartSheet"] = "smartSheet";
  DOCUMENT_TYPE_DESC["smartCanvas"] = "smartCanvas";
  DOCUMENT_TYPE_DESC["flowchart"] = "flowchart";
  DOCUMENT_TYPE_DESC["mind"] = "mind";
  DOCUMENT_TYPE_DESC["pdf"] = "pdf";
})(DOCUMENT_TYPE_DESC || (DOCUMENT_TYPE_DESC = {}));
/**
 * 文档类型描述和文档类型的映射表
 */


var DOCUMENT_TYPE_MAP = (_a = {}, _a[DOCUMENT_TYPE_DESC.doc] = DOCUMENT_TYPE.doc, _a[DOCUMENT_TYPE_DESC.sheet] = DOCUMENT_TYPE.sheet, _a[DOCUMENT_TYPE_DESC.slide] = DOCUMENT_TYPE.slide, _a[DOCUMENT_TYPE_DESC.smartSheet] = DOCUMENT_TYPE.smartSheet, _a[DOCUMENT_TYPE_DESC.smartCanvas] = DOCUMENT_TYPE.smartCanvas, _a[DOCUMENT_TYPE_DESC.flowchart] = DOCUMENT_TYPE.flowchart, _a[DOCUMENT_TYPE_DESC.mind] = DOCUMENT_TYPE.mind, _a[DOCUMENT_TYPE_DESC.pdf] = DOCUMENT_TYPE.pdf, _a);
/**
 * 文档类型和文档类型描述的映射表
 */

var DOCUMENT_TYPE_DESC_MAP = (_b = {}, _b[DOCUMENT_TYPE.doc] = DOCUMENT_TYPE_DESC.doc, _b[DOCUMENT_TYPE.sheet] = DOCUMENT_TYPE_DESC.sheet, _b[DOCUMENT_TYPE.slide] = DOCUMENT_TYPE_DESC.slide, _b[DOCUMENT_TYPE.smartSheet] = DOCUMENT_TYPE_DESC.smartSheet, _b[DOCUMENT_TYPE.smartCanvas] = DOCUMENT_TYPE_DESC.smartCanvas, _b[DOCUMENT_TYPE.flowchart] = DOCUMENT_TYPE_DESC.flowchart, _b[DOCUMENT_TYPE.mind] = DOCUMENT_TYPE_DESC.mind, _b[DOCUMENT_TYPE.pdf] = DOCUMENT_TYPE_DESC.pdf, _b);
/**
 * 文档的权限策略，私有还是公开等
 */

var DOCUMENT_POLICY;

(function (DOCUMENT_POLICY) {
  DOCUMENT_POLICY[DOCUMENT_POLICY["private"] = 0] = "private";
  DOCUMENT_POLICY[DOCUMENT_POLICY["partialShare"] = 1] = "partialShare";
  DOCUMENT_POLICY[DOCUMENT_POLICY["canRead"] = 2] = "canRead";
  DOCUMENT_POLICY[DOCUMENT_POLICY["canEdit"] = 3] = "canEdit";
})(DOCUMENT_POLICY || (DOCUMENT_POLICY = {}));
/**
 * 文档的状态
 */


var DOCUMENT_STATUS;

(function (DOCUMENT_STATUS) {
  DOCUMENT_STATUS["new"] = "new";
  DOCUMENT_STATUS["local"] = "local";
  DOCUMENT_STATUS["deleted"] = "deleted";
  DOCUMENT_STATUS["normal"] = "normal";
})(DOCUMENT_STATUS || (DOCUMENT_STATUS = {}));
/**
 * 列表页文件类型
 */


var LIST_INFO_TYPE;

(function (LIST_INFO_TYPE) {
  LIST_INFO_TYPE[LIST_INFO_TYPE["file"] = 1] = "file";
  LIST_INFO_TYPE[LIST_INFO_TYPE["folder"] = 2] = "folder"; // 文件夹
})(LIST_INFO_TYPE || (LIST_INFO_TYPE = {}));
/**
 * 文件在列表中的分类
 */


var LIST_TYPE;

(function (LIST_TYPE) {
  LIST_TYPE[LIST_TYPE["trash"] = 3] = "trash";
  LIST_TYPE[LIST_TYPE["share"] = 4] = "share";
  LIST_TYPE[LIST_TYPE["myDoc"] = 5] = "myDoc";
  LIST_TYPE[LIST_TYPE["recent"] = 6] = "recent";
  LIST_TYPE[LIST_TYPE["start"] = 7] = "start";
})(LIST_TYPE || (LIST_TYPE = {}));
/**
 * 文档数据记录的类型
 */


var DOCUMENT_DATA_TYPE;

(function (DOCUMENT_DATA_TYPE) {
  DOCUMENT_DATA_TYPE["init"] = "init";
  DOCUMENT_DATA_TYPE["document"] = "document";
  DOCUMENT_DATA_TYPE["workbook"] = "workbook";
  DOCUMENT_DATA_TYPE["chunk"] = "chunk";
  DOCUMENT_DATA_TYPE["accepted"] = "accepted";
  DOCUMENT_DATA_TYPE["missChange"] = "misschange";
  DOCUMENT_DATA_TYPE["newChange"] = "newchange";
  DOCUMENT_DATA_TYPE["committing"] = "commiting";
  DOCUMENT_DATA_TYPE["waiting"] = "watting";
  DOCUMENT_DATA_TYPE["queue"] = "queue";
})(DOCUMENT_DATA_TYPE || (DOCUMENT_DATA_TYPE = {}));

/**
 * 数据库名
 */
// 正式环境数据库名
var DB_NAME = 'TencentDocs'; // 非正式环境数据库名

var DB_NAME_TESTENV = 'TencentDocs_TestEnv';
/**
 * 数据库表名
 */

var TABLE_NAME;

(function (TABLE_NAME) {
  // 文档状态表
  TABLE_NAME["documentStatus"] = "DocumentStatus"; // 文档扩展数据表

  TABLE_NAME["documentEntities"] = "DocumentEntities"; // 预拉取文档id表

  TABLE_NAME["newDocumentIds"] = "NewDocumentIds"; // 文档信息表（与客户端列表页共享）

  TABLE_NAME["padinfo"] = "PadInfo"; // 文档离线编辑的本地数据表

  TABLE_NAME["offlineData"] = "OfflineData"; // 文档已落盘数据表

  TABLE_NAME["documentData"] = "DocumentData"; // 用户数据表

  TABLE_NAME["Users"] = "Users";
})(TABLE_NAME || (TABLE_NAME = {}));

/**
 * 登录类型
 */
var ACCOUNT_TYPE;

(function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE[ACCOUNT_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QQ"] = 1] = "QQ";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WX"] = 2] = "WX";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK"] = 3] = "WORK";
  ACCOUNT_TYPE[ACCOUNT_TYPE["EMAIL"] = 4] = "EMAIL";
  ACCOUNT_TYPE[ACCOUNT_TYPE["PHONE"] = 8] = "PHONE";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK_COMBINATION"] = 9] = "WORK_COMBINATION";
  ACCOUNT_TYPE[ACCOUNT_TYPE["TOWER"] = 10] = "TOWER";
  ACCOUNT_TYPE[ACCOUNT_TYPE["ROBOT"] = 11] = "ROBOT";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QFYF"] = 12] = "QFYF";
  ACCOUNT_TYPE[ACCOUNT_TYPE["OPEN"] = 13] = "OPEN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["MEETING"] = 14] = "MEETING";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
/* eslint-disable @typescript-eslint/ban-types */
// b端登陆类型


var LOGINTYPE;

(function (LOGINTYPE) {
  LOGINTYPE[LOGINTYPE["UNKNOWN"] = 0] = "UNKNOWN";
  /**
  * 微信登陆
  **/

  LOGINTYPE[LOGINTYPE["WECHAT"] = 4] = "WECHAT";
  /**
  * 企业微信登陆
  **/

  LOGINTYPE[LOGINTYPE["WEWORK"] = 3] = "WEWORK";
})(LOGINTYPE || (LOGINTYPE = {}));

var BIND_TYPE;

(function (BIND_TYPE) {
  /**
   * 有绑定账号
   */
  BIND_TYPE["BINDING"] = "BINDING";
  /**
   * 没有绑定账号
   */

  BIND_TYPE["UNBIND"] = "UNBIND";
})(BIND_TYPE || (BIND_TYPE = {}));

var VipType;

(function (VipType) {
  /**
   * 常规vip类型
   */
  VipType["NORMAL"] = "NORMAL";
  /**
   * 超级vip类型
   */

  VipType["SUPER"] = "SUPER";
  /**
   * 没有vip
   */

  VipType["NONE"] = "NONE";
  /**
   * 过期的 VIP
   */

  VipType["EXPIRED"] = "EXPIRED";
})(VipType || (VipType = {}));

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __metadata(metadataKey, metadataValue) {
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var randomRange = 2147483648;
/**
 * 文档变更记录Model，目前关键帧记录和离线编辑记录Model实际上存储字段相同，抽象一个公共Model
 */

var BaseChangeModel =
/** @class */
function (_super) {
  __extends(BaseChangeModel, _super);

  function BaseChangeModel(option) {
    var _this = this;

    var _a, _b, _c, _d, _e, _f;

    _this = _super.call(this) || this; // 是否是默认关键帧

    _this.isDefaultChunk = false; // 必填字段赋值

    _this.uid = option.uid;
    _this.type = option.type;
    _this.data = option.data;
    _this.dataVersion = option.dataVersion;
    _this.docType = option.docType;
    _this.subId = option.subId;
    _this.secretId = option.secretId;
    _this.version = option.version;
    _this.globalPadId = option.globalPadId; // 可选字段给默认值

    _this.taskId = (_a = option.taskId) !== null && _a !== void 0 ? _a : _this.getTaskId();
    _this.isDefaultChunk = (_b = option.isDefaultChunk) !== null && _b !== void 0 ? _b : false;
    _this.chunkId = (_c = option.chunkId) !== null && _c !== void 0 ? _c : 0;
    _this.docStatus = (_d = option.docStatus) !== null && _d !== void 0 ? _d : DOCUMENT_STATUS.normal;
    _this.createTimestamp = (_e = option.createTimestamp) !== null && _e !== void 0 ? _e : Date.now();
    _this.lastModifyTimestamp = (_f = option.lastModifyTimestamp) !== null && _f !== void 0 ? _f : Date.now();
    _this.key = _this.getKey();
    _this.subGlobalPadId = option.subGlobalPadId;
    _this.subDocType = option.subDocType;
    return _this;
  }

  BaseChangeModel.prototype.getTaskId = function () {
    return Math.ceil(Math.random() * randomRange);
  };

  BaseChangeModel.prototype.getKey = function () {
    var key;

    if (this.type === DOCUMENT_DATA_TYPE.init) {
      key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.uid);
    } else if (this.type === DOCUMENT_DATA_TYPE.document) {
      key = "".concat(this.globalPadId, "_").concat(this.uid, "_version_").concat(this.version);
    } else if (this.type === DOCUMENT_DATA_TYPE.workbook) {
      key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.uid, "_version_").concat(this.version);
    } else if (this.type === DOCUMENT_DATA_TYPE.chunk) {
      key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.chunkId, "_").concat(this.uid, "_version_").concat(this.version);
    } else {
      key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.uid, "_taskId_").concat(this.taskId);
    }

    return key;
  };

  __decorate([primary(), __metadata("design:type", String)], BaseChangeModel.prototype, "key", void 0);

  __decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "secretId", void 0);

  __decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "globalPadId", void 0);

  __decorate([index(), __metadata("design:type", Number)], BaseChangeModel.prototype, "version", void 0);

  __decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "type", void 0);

  __decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "uid", void 0);

  __decorate([index(), field('subSheetId'), __metadata("design:type", String)], BaseChangeModel.prototype, "subId", void 0);

  __decorate([index(), __metadata("design:type", Number)], BaseChangeModel.prototype, "chunkId", void 0);

  __decorate([field(), __metadata("design:type", Number)], BaseChangeModel.prototype, "taskId", void 0);

  __decorate([field('_data'), __metadata("design:type", String)], BaseChangeModel.prototype, "data", void 0);

  __decorate([field(), __metadata("design:type", Number)], BaseChangeModel.prototype, "docType", void 0);

  __decorate([field('padStatus'), __metadata("design:type", String)], BaseChangeModel.prototype, "docStatus", void 0);

  __decorate([field('createTime'), __metadata("design:type", Number)], BaseChangeModel.prototype, "createTimestamp", void 0);

  __decorate([field(), __metadata("design:type", Number)], BaseChangeModel.prototype, "lastModifyTimestamp", void 0);

  __decorate([field('dver'), __metadata("design:type", String)], BaseChangeModel.prototype, "dataVersion", void 0);

  __decorate([field('default'), __metadata("design:type", Object)], BaseChangeModel.prototype, "isDefaultChunk", void 0);

  __decorate([field(), __metadata("design:type", String)], BaseChangeModel.prototype, "subGlobalPadId", void 0);

  __decorate([field(), __metadata("design:type", Number)], BaseChangeModel.prototype, "subDocType", void 0);

  return BaseChangeModel;
}(Model);

/**
 * 文档信息表
 * ❌❌❌ PS：该Model中的字段对齐后台字段，大部分为使用下划线命名的参数（不符合代码规范，后续协商优化）
 */

var PadInfo =
/** @class */
function (_super) {
  __extends(PadInfo, _super);

  function PadInfo() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.addListTimestamp = 0;
    _this.attribute = null; // 文档权限策略，默认为私有权限

    _this.docPolicy = DOCUMENT_POLICY.private;
    _this.docPrivilege = null;
    _this.folderPolicy = 0;
    _this.folderPrivilege = null; // 是否手动离线

    _this.isManualOffline = false; // 是否离线缓存

    _this.isOfflineCache = false; // 是否渲染了快照

    _this.hasSnapShot = false; // 是否添加到我的文档

    _this.isAddedToMy = 0; // 是否为星标文档

    _this.isCollected = 0; // 当前用户是否为所有者

    _this.isOwner = 1; // 是否置顶

    _this.isPinned = 0; // 是否为快捷方式

    _this.isShortcut = 0; // 用户是否手动修改过标题

    _this.isUserChangeTitle = false;
    _this.lastCollectTimestamp = 0;
    _this.lastDeleteTimestamp = 0;
    _this.parents = [];
    return _this;
  }

  __decorate([primary(), __metadata("design:type", String)], PadInfo.prototype, "key", void 0);

  __decorate([index(), __metadata("design:type", String)], PadInfo.prototype, "secretId", void 0);

  __decorate([index(), __metadata("design:type", String)], PadInfo.prototype, "globalPadId", void 0);

  __decorate([index(), __metadata("design:type", String)], PadInfo.prototype, "uid", void 0);

  __decorate([field('add_list_ts'), __metadata("design:type", Object)], PadInfo.prototype, "addListTimestamp", void 0);

  __decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "attribute", void 0);

  __decorate([field(), __metadata("design:type", Number)], PadInfo.prototype, "childrenLength", void 0);

  __decorate([field('client_version'), __metadata("design:type", String)], PadInfo.prototype, "clientVersion", void 0);

  __decorate([field('create_ts'), __metadata("design:type", Number)], PadInfo.prototype, "createTimestamp", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "creator", void 0);

  __decorate([field('creator_domain'), __metadata("design:type", String)], PadInfo.prototype, "creatorDomain", void 0);

  __decorate([field('doc_icon'), __metadata("design:type", String)], PadInfo.prototype, "icon", void 0);

  __decorate([field('doc_policy'), __metadata("design:type", Number)], PadInfo.prototype, "docPolicy", void 0);

  __decorate([field('doc_privilege'), __metadata("design:type", Object)], PadInfo.prototype, "docPrivilege", void 0);

  __decorate([field('doc_thumbnail'), __metadata("design:type", String)], PadInfo.prototype, "thumbnail", void 0);

  __decorate([field('doc_type'), __metadata("design:type", Number)], PadInfo.prototype, "docType", void 0);

  __decorate([field('doc_type_desc'), __metadata("design:type", String)], PadInfo.prototype, "docTypeDesc", void 0);

  __decorate([field('doc_url'), __metadata("design:type", String)], PadInfo.prototype, "url", void 0);

  __decorate([field('domain_id'), __metadata("design:type", String)], PadInfo.prototype, "domainId", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "dver", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "folder", void 0);

  __decorate([field('folder_id'), __metadata("design:type", String)], PadInfo.prototype, "folderId", void 0);

  __decorate([field('folder_policy'), __metadata("design:type", Object)], PadInfo.prototype, "folderPolicy", void 0);

  __decorate([field('folder_privilege'), __metadata("design:type", Object)], PadInfo.prototype, "folderPrivilege", void 0);

  __decorate([field('isDelete'), __metadata("design:type", Boolean)], PadInfo.prototype, "isDeleted", void 0);

  __decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "isManualOffline", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isMyCreated", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isMydoc", void 0);

  __decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "isOfflineCache", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isRencent", void 0);

  __decorate([field('isShareme'), __metadata("design:type", Boolean)], PadInfo.prototype, "isShareToMe", void 0);

  __decorate([field('isSnapShot'), __metadata("design:type", Object)], PadInfo.prototype, "hasSnapShot", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isStar", void 0);

  __decorate([field('is_added_my'), __metadata("design:type", Object)], PadInfo.prototype, "isAddedToMy", void 0);

  __decorate([field('is_collected'), __metadata("design:type", Object)], PadInfo.prototype, "isCollected", void 0);

  __decorate([field('is_owner'), __metadata("design:type", Object)], PadInfo.prototype, "isOwner", void 0);

  __decorate([field('is_pinned'), __metadata("design:type", Object)], PadInfo.prototype, "isPinned", void 0);

  __decorate([field('is_shortcut'), __metadata("design:type", Object)], PadInfo.prototype, "isShortcut", void 0);

  __decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "isUserChangeTitle", void 0);

  __decorate([field('lastSyncTime'), __metadata("design:type", Number)], PadInfo.prototype, "lastSyncTimestamp", void 0);

  __decorate([field('last_browse_ts'), __metadata("design:type", Number)], PadInfo.prototype, "lastBrowseTimestamp", void 0);

  __decorate([field('last_collect_ts'), __metadata("design:type", Object)], PadInfo.prototype, "lastCollectTimestamp", void 0);

  __decorate([field('last_delete_ts'), __metadata("design:type", Object)], PadInfo.prototype, "lastDeleteTimestamp", void 0);

  __decorate([field('last_modify_ts'), __metadata("design:type", Number)], PadInfo.prototype, "lastModifyTimestamp", void 0);

  __decorate([field('last_modify_nick'), __metadata("design:type", String)], PadInfo.prototype, "lastModifyNick", void 0);

  __decorate([field('last_modify_uid'), __metadata("design:type", String)], PadInfo.prototype, "lastModifyUid", void 0);

  __decorate([field('last_pinned_ts'), __metadata("design:type", Number)], PadInfo.prototype, "lastPinnedTimestamp", void 0);

  __decorate([field('list_info_type'), __metadata("design:type", Number)], PadInfo.prototype, "listInfoType", void 0);

  __decorate([field('list_type'), __metadata("design:type", Number)], PadInfo.prototype, "listType", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "offlineCommiting", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "offlineCommitSuccessd", void 0);

  __decorate([field('origin_folder_id'), __metadata("design:type", String)], PadInfo.prototype, "originFolderId", void 0);

  __decorate([field('owner_nick'), __metadata("design:type", String)], PadInfo.prototype, "ownerNick", void 0);

  __decorate([field('owner_uid'), __metadata("design:type", String)], PadInfo.prototype, "ownerUid", void 0);

  __decorate([field('pad_id'), __metadata("design:type", String)], PadInfo.prototype, "padId", void 0);

  __decorate([field('parent_folder_id'), __metadata("design:type", String)], PadInfo.prototype, "parentFolderId", void 0);

  __decorate([field(), __metadata("design:type", Array)], PadInfo.prototype, "parents", void 0);

  __decorate([field(), __metadata("design:type", Number)], PadInfo.prototype, "privilege", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "status", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "title", void 0);

  __decorate([field(), __metadata("design:type", Number)], PadInfo.prototype, "type", void 0);

  __decorate([field('uncommit'), __metadata("design:type", Boolean)], PadInfo.prototype, "hasLocalChanges", void 0);

  __decorate([field('doc_sub_type'), __metadata("design:type", Number)], PadInfo.prototype, "docSubType", void 0);

  __decorate([field('official_auth_info'), __metadata("design:type", String)], PadInfo.prototype, "officialAuthInfo", void 0);

  __decorate([field('personalize_info'), __metadata("design:type", String)], PadInfo.prototype, "personalizeInfo", void 0);

  __decorate([field('nativeEngineStatusRecord'), __metadata("design:type", String)], PadInfo.prototype, "nativeEngineStatusRecord", void 0);

  __decorate([field('nativeEngineDocPrivilege'), __metadata("design:type", String)], PadInfo.prototype, "nativeEngineDocPrivilege", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "data", void 0);

  __decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "ext", void 0);

  __decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isOfflineCacheByNative", void 0);

  __decorate([field('mime_type'), __metadata("design:type", String)], PadInfo.prototype, "mimeType", void 0);

  __decorate([field('owner_vip_info'), __metadata("design:type", String)], PadInfo.prototype, "ownerVipInfo", void 0);

  PadInfo = __decorate([table(TABLE_NAME.padinfo)], PadInfo);
  return PadInfo;
}(Model);

/**
 * 文档状态表，用于记录文档数据同步的状态
 */

var DocumentId =
/** @class */
function (_super) {
  __extends(DocumentId, _super);

  function DocumentId() {
    var _this = _super !== null && _super.apply(this, arguments) || this; // 文档是否已被用于创建，客户端在使用该标记位


    _this.isCreated = false;
    return _this;
  }

  __decorate([primary(), __metadata("design:type", String)], DocumentId.prototype, "globalPadId", void 0);

  __decorate([field(), __metadata("design:type", String)], DocumentId.prototype, "secretId", void 0);

  __decorate([field(), __metadata("design:type", Number)], DocumentId.prototype, "documentType", void 0);

  __decorate([field(), __metadata("design:type", String)], DocumentId.prototype, "localPadId", void 0);

  __decorate([field(), __metadata("design:type", Object)], DocumentId.prototype, "isCreated", void 0);

  DocumentId = __decorate([table(TABLE_NAME.newDocumentIds)], DocumentId);
  return DocumentId;
}(Model);

/**
 * 文档状态表，用于记录文档数据同步的状态
 */

var DocumentStatus =
/** @class */
function (_super) {
  __extends(DocumentStatus, _super);

  function DocumentStatus() {
    var _this = _super !== null && _super.apply(this, arguments) || this; // 文档最新数据同步的时间


    _this.lastSyncTimestamp = 0;
    return _this;
  }

  __decorate([primary(), __metadata("design:type", String)], DocumentStatus.prototype, "globalPadId", void 0);

  __decorate([index(), __metadata("design:type", String)], DocumentStatus.prototype, "secretId", void 0);

  __decorate([index(), __metadata("design:type", String)], DocumentStatus.prototype, "uid", void 0);

  __decorate([field('lastSyncTime'), __metadata("design:type", Object)], DocumentStatus.prototype, "lastSyncTimestamp", void 0);

  __decorate([field(), __metadata("design:type", Number)], DocumentStatus.prototype, "lastErrorTimestamp", void 0);

  DocumentStatus = __decorate([table(TABLE_NAME.documentStatus)], DocumentStatus);
  return DocumentStatus;
}(Model);

/**
 * 文档的扩展数据表
 *
 */

var DocumentEntity =
/** @class */
function (_super) {
  __extends(DocumentEntity, _super);

  function DocumentEntity() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  __decorate([primary(), __metadata("design:type", String)], DocumentEntity.prototype, "key", void 0);

  __decorate([field(), __metadata("design:type", Object)], DocumentEntity.prototype, "data", void 0);

  DocumentEntity = __decorate([table(TABLE_NAME.documentEntities)], DocumentEntity);
  return DocumentEntity;
}(Model);

var DocumentData =
/** @class */
function (_super) {
  __extends(DocumentData, _super);

  function DocumentData() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DocumentData = __decorate([table(TABLE_NAME.documentData)], DocumentData);
  return DocumentData;
}(BaseChangeModel);

/**
 * 文档本地离线数据表
 */

var OfflineData =
/** @class */
function (_super) {
  __extends(OfflineData, _super);

  function OfflineData() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OfflineData = __decorate([table(TABLE_NAME.offlineData)], OfflineData);
  return OfflineData;
}(BaseChangeModel);

var UserInfo =
/** @class */
function (_super) {
  __extends(UserInfo, _super);

  function UserInfo(option) {
    var _this = this;

    var _a, _b, _c;

    _this = _super.call(this) || this;
    _this.docId = option.docId;
    _this.pageType = option.pageType;
    _this.updateTime = option.updateTime;
    _this.tinyId = option.tinyId;
    _this.wedriveUin = option.wedriveUin;
    _this.wedocOpenId = option.wedocOpenId;
    _this.nowUserIndex = (_a = option.nowUserIndex) !== null && _a !== void 0 ? _a : '';
    _this.corpId = option.corpId;
    _this.corpName = option.corpName;
    _this.englishName = option.englishName;
    _this.loginType = option.loginType;
    _this.uidSource = option.uidSource;
    _this.uin = option.uin;
    _this.userId = option.userId;
    _this.userName = option.userName;
    _this.userPic = option.userPic;
    _this.settings = option.settings;
    _this.bindUserInfo = (_b = option.bindUserInfo) !== null && _b !== void 0 ? _b : {
      type: BIND_TYPE.UNBIND,
      userName: '',
      userPic: '',
      accountType: ACCOUNT_TYPE.UNKNOWN
    };
    _this.vipUserInfo = (_c = option.vipUserInfo) !== null && _c !== void 0 ? _c : {
      type: VipType.NONE,
      beginTime: 0,
      endTime: 0
    };
    _this.key = "".concat(_this.pageType, "-").concat(_this.docId, "-").concat(_this.tinyId);
    return _this;
  }

  __decorate([primary(), __metadata("design:type", String)], UserInfo.prototype, "key", void 0);

  __decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "tinyId", void 0);

  __decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "nowUserIndex", void 0);

  __decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "docId", void 0);

  __decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "pageType", void 0);

  __decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "wedriveUin", void 0);

  __decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "wedocOpenId", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "corpId", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "corpName", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "englishName", void 0);

  __decorate([field(), __metadata("design:type", Number)], UserInfo.prototype, "loginType", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "openId", void 0);

  __decorate([field(), __metadata("design:type", Number)], UserInfo.prototype, "uidSource", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "uin", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "userId", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "userName", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "userPic", void 0);

  __decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "updateTime", void 0);

  __decorate([field(), __metadata("design:type", Object)], UserInfo.prototype, "settings", void 0);

  __decorate([field(), __metadata("design:type", Object)], UserInfo.prototype, "bindUserInfo", void 0);

  __decorate([field(), __metadata("design:type", Object)], UserInfo.prototype, "vipUserInfo", void 0);

  UserInfo = __decorate([table(TABLE_NAME.Users), __metadata("design:paramtypes", [Object])], UserInfo);
  return UserInfo;
}(Model);

export { ACCOUNT_TYPE, BIND_TYPE, BaseChangeModel, DB_NAME, DB_NAME_TESTENV, DOCUMENT_DATA_TYPE, DOCUMENT_POLICY, DOCUMENT_STATUS, DOCUMENT_TYPE, DOCUMENT_TYPE_DESC, DOCUMENT_TYPE_DESC_MAP, DOCUMENT_TYPE_MAP, DocumentData, DocumentEntity, DocumentId, DocumentStatus, LIST_INFO_TYPE, LIST_TYPE, OfflineData, PadInfo, TABLE_NAME, UserInfo, VipType };
//# sourceMappingURL=index.js.map
